@if (articleResult$ | async; as articleResult) {
    @if (articleResult.articles[0]; as document) {
        <capital-structure [capitalstructure]="document.structure" [instrumentIDLookup]="document.instrumentIDLookup" [classesLookup]="document.classesLookup" [expandAll]="expandAll"></capital-structure>
    }
}
